<template>
  <list-layout :tableTools="false">
    <template slot="header">
      <slot name="header" />
      <div class="px-4 lg:px-10 font-medium dark:text-white mb-2 flex gap-4 items-center">
        <h2>{{ step.description }}</h2>
        <el-form ref="ruleForm" :rules="rules" :model="form" class="flex-1">
          <el-form-item prop="issuer">
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template slot="table-core">
      <base-table-pagination v-if="!isLower1650 || isLower1024"
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <base-table-pagination-mini v-else
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination-mini>
      <div class="flex flex-row md:flex-col w-100">
        <base-table-search @toggleFilters="$emit('toggleFilters')" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags :tags="tags" hide-save @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component
        v-model="form.issuer"
        value-key="IdCIFEmpresa"
        value-type="data-item"
        single select-on-row-click
        :spanish="spanish"
        :data="data"
        :kendo="kendo"
        :loading="isGeneralLoading"
        :selectedField="selectedField"
        :update-columns="false"
        @datastatechange="dataStateChange"
        @selectionchange="onSelectionChange">
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <reset-dialog custom-class="min-width-dialog" :dialogOpen="ResetDialog" :mobile-version="isLower1024" @toggleDialog="toggleReset" @applyDialog="setIssuer"/>
      <slot name="layout-extend" />
    </template>
  </list-layout>
</template>

<script>
import { i18n } from '@/i18n'
import { getCompaniesExtended } from '@/services/companies/getCompaniesExtended'
import { getValidateEmpresaEmisora } from '@/services/configurations/getValidateEmpresaEmisora'

import ListLayout from '@/components/layout/ListLayout.vue'
import ResetDialog from '@/components/Step1ResetDialog.vue'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'

export default {
  name: 'step0-issuer',
  components: {
    // Loading,
    ListLayout,
    ResetDialog,
    KendoGridComponent,
  },
  props: {
    step: Object,
    value: [Number, String],
    isFirstStep: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      stepId: '0',
      // Searches
      saveSearchDialog: false,
      // All
      spanish: true,
      ResetDialog: false,
      newIssuer: '',
      vuexnamespace: 'invoicesIssuing/0',
      selectedField: 'selected',
      loadingDataTable: false,
      data: null,
      rules: {
        issuer: [
          {
            required: true,
            message: i18n.t('app.select_data'),
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  computed: {
    form: function () {
      return this.$store.getters[this.vuexnamespace + '/form']
    },
    oldIssuer: function () {
      return this.$store.getters[this.vuexnamespace + '/form']?.oldIssuer
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isClientFilterActive () {
      return this.$store.getters[this.vuexnamespace + '/isClientFilterActive']
    },
    actualFilterIMenu () {
      return this.$store.getters['app/idClienteFilterIMenu']
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    isLower1650: function () {
      return this.$store.getters['app/getIsLower1650']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading || this.loadingCompanies || this.loadingCompanyData || this.loadingContacts
    },
    tags: function () {
      var tags = this.$store.getters[this.vuexnamespace + '/getTags']
      if (this.status !== undefined && this.status !== 99999) {
        tags = tags.filter(x => x[0] !== 'estadoExtra')
      }
      return tags
      // return this.status === undefined || this.status === 99999 ? tags : tags.filter(x => x[0] !== 'estadoExtra')
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
  },
  watch: {
    actualFilterIMenu: async function () {
      if (this.actualFilterIMenu === null || this.actualFilterIMenu === undefined || this.actualFilterIMenu === '') {
        await this.removeAllTagsHandler()
      }
    }
  },
  async mounted () {
    this.prepareStep()
  },
  methods: {
    prepareStep: async function () {
      this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
      if (this.actualFilterIMenu && this.isClientFilterActive) {
        const filter = this.masterFilters
        filter.empresa = { label: i18n.t('clients.entity_name'), value: this.actualFilterIMenu }
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      }
      this.data = await this.applyFilters()
      if (this.data.length === 1) {
        this.form.issuer = this.data[0]
        const isIssuerValid = await this.validateIssuer(this.form.issuer.IdCIFEmpresa)
        if (isIssuerValid) {
          this.validate(undefined, true)
          this.$emit('change', this.form.issuer)
        }
      }
    },
    resetForm: function (excluded = []) {
      if (!excluded.includes(this.stepId)) {
        this.form.issuer = ''
      }
    },
    validate: function (callback = (valid) => {}, doInput = true) {
      this.$refs.ruleForm.validate(valid => {
        if (valid && doInput && (this.isFirstStep || this.value === '') && [3, 7, 8].includes(this.role)) {
          this.$emit('input', this.form.issuer?.idCliente ?? '')
        }
        callback(valid) 
      })
    },
    toggleReset: function () {
      this.ResetDialog = !this.ResetDialog
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    getParamsFilter (data) {
      return {
        idDistribuidor: data.distribuidor ? data.distribuidor.value.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value.idCliente : null,
        CIF: data.cif ? data.cif.value : null,
        razonSocial: data.name ? data.name.value : null,
        direccion: data.direccion ? data.direccion.value : null,
        registro_mercantil: data.registro_mercantil ? data.registro_mercantil.value : null,
        email: data.email ? data.email.value : null,
        codigoPostal: data.codigo_postal ? data.codigo_postal.value : null,
        telefono: data.telefono ? data.telefono.value : null,
        codigoPais: data.pais ? data.pais.value : null,
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      this.$store.commit('setIsLoading', true)
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      this.$store.commit(this.vuexnamespace + '/setClientFilterActive', !!((data.empresa && data.empresa.value.idCliente === this.actualFilterIMenu?.idCliente)))
      const params = this.getParamsFilter(data)
      const obj = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      if (data.ActiveReports) {
        obj.ActiveReports = data.ActiveReports.value
      }

      try {
        const data = await this.getItemsData(obj, params)
        return data
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
      return null
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      const data = res.respuesta

      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false

      if (pagination.currentPage > pagination.totalPages) {
        this.applyFiltersHandler()
      }

      return data
    },
    async getMainData (orders, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getCompaniesExtended(orders, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters()
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      try {
        this.data = await this.applyFilters()
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    removeFilterTagHanlder: async function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.data = await this.applyFilters()
    },
    removeAllTagsHandler: async function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.data = await this.applyFilters()
    },
    unselect: function () {
      this.resetForm()
    },
    setIssuer: async function (cancelReset = false) {
      if (cancelReset) {
        this.form.issuer = this.oldIssuer
      } else {
        const isIssuerValid = this.form.issuer === '' || await this.validateIssuer(this.form.issuer.IdCIFEmpresa)
        if (isIssuerValid) {
          this.$emit('reset', { excluded: [this.stepId] })
          this.validate(undefined, true)
          this.form.oldIssuer = this.form.issuer
          this.$emit('change', this.form.issuer)
        }
      }
    },
    onSelectionChange: async function () { 
      if (this.oldIssuer === '') {
        const isIssuerValid = await this.validateIssuer(this.form.issuer.IdCIFEmpresa)
        if (isIssuerValid) {
          this.validate(undefined, true)
          this.form.oldIssuer = this.form.issuer
          this.$emit('change', this.form.issuer)
        }
      } else if (this.form.issuer !== this.oldIssuer) {
        this.toggleReset()
      }
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    validateIssuer: async function (id) {
      this.$store.commit('setIsLoading', true)
      try {
        const params = {
          idCifEmpresa: id
        }
        const data = await getValidateEmpresaEmisora(params)
        if (data.blnError === true) {
          if (data.codError === 'CCVEE004') {
            this.$emit('open-dialog')
          } else {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
          }
        }
        return data.Respuesta
      } catch (error) {
        this.doFeedback()
        return false
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    }
  },
}
</script>

<style>

</style>
